import React from 'react';
import BomModelList from '../../components/bomModel/BomModelList';
import { useParams } from 'react-router-dom';

const BomModels: React.FC = () => {
    let { whiteModelId } = useParams();

    return (<div>
        <BomModelList whiteModelId={parseInt(whiteModelId || '0')} />
    </div>)
};

export default BomModels;